import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Input from '../../../components/Elements/input';
import { getMasterData } from '../../AddComplain/api';
import { actionNotifier } from '../../../components/ui/toast';
import { notiflixLoaderEnd, notiflixLoaderStart } from '../../../components/ui/notification';
import { addSchoolImage } from './api';
import ReactSelect from 'react-select';

const SchoolReport = (props) => {
    const [school, setAllSchool] = useState([]);
    const [formData, setFormData] = useState({
        schoolCode: '',
        school: '',
        date: '',
    });
    const [imagePreviews, setImagePreviews] = useState([]);
    

    const getSchool = async (string) => {
        let data = await getMasterData(`?type=SCHOOL&blockName=${string}`);
        if (data) {
            setAllSchool(data);
        }
    };

    useEffect(() => {
        getSchool(props.auth.auth.blockName);
    }, [props.auth.auth.blockName]);

    const handleChange = (e, fieldName) => {
        if (e.target.type === 'file') {
            const file = e.target.files[0];
            setFormData((prevState) => ({
                ...prevState,
                [fieldName]: file, // Save the selected file to the formData
            }));
            setImagePreviews([...imagePreviews, URL.createObjectURL(file)]);
        } else {
            // For regular inputs
            const value = e.target.value;
            setFormData((prevState) => ({
                ...prevState,
                [fieldName]: value,
            }));
        }
        console.log(formData)
    };

    const handleSchoolChange = (selectedOption, fieldName) => {
        setFormData((prevState) => ({
            ...prevState,
            [fieldName]: selectedOption.value,
            school: selectedOption.label,
        }));
        console.log(formData)
    };

    useEffect(() => {
        const fetchData = async () => {
            if (formData.schoolCode && formData.schoolPhoto) {
                const fd = new FormData();
                // Append fields to FormData
                fd.append('udiseCode', formData.schoolCode);
                fd.append('school', formData.schoolPhoto);
                fd.append('createdAt', formData.date)
                notiflixLoaderStart();
                try {
                    let res = await addSchoolImage(fd);
                    if (res.status) {
                        actionNotifier.success("Submitted Successfully");
                        setFormData({
                            ...formData,
                            schoolPhoto: null,
                        });
                        // setImagePreview(null);
                    } else {
                        actionNotifier.error(res.message);
                    }
                } catch (error) {
                    console.error("Error:", error);
                    actionNotifier.error("An error occurred while submitting.");
                } finally {
                    notiflixLoaderEnd();
                }
            } else {
                // console.log("Something Went Wrong!! Please refresh the page");
            }
        };
        fetchData();
    }, [formData]);

    return (
        <>
            <h4 className="m-3">कृपया निरिक्षण की फोटो अपलोड करें</h4>
            <div className="row">
                <div className="col-md-6 m-3">
                    <span>Select School</span>
                    <ReactSelect
                        options={school.map((s) => ({
                            value: s.schoolUdiseCode,
                            label: `${s.schoolName}(${s.schoolUdiseCode})`,
                        }))}
                        value={{ value: formData.schoolCode, label: formData.school }}
                        onChange={(selectedOption) => handleSchoolChange(selectedOption, 'schoolCode')}
                    />
                </div>

                <div className="col-md-6  m-3">
                    <Input
                        title={"कृपया फोटो अपलोड की तिथि चुने"}
                        type={"date"}
                        name={"date"}
                        required={true}
                        value={formData.date}
                        onChange={(e) => handleChange(e, 'date')}
                    />
                </div>
            </div>
            {
                formData.schoolCode && <div className="row ">
                    <div className="col-md-6 ">
                        <p className='ml-3'>The Photo Should Be Captured through NoteCam App Only !</p>
                        <input
                            type="file"
                            name="schoolPhoto"
                            className="form-control ml-3"
                            onChange={(e) => handleChange(e, 'schoolPhoto')}
                            accept="image/png, image/gif, image/jpeg"
                        />
                    </div>
                </div>
            }
            {imagePreviews.map((preview, index) => (
                <div key={index} className="row">
                    <div className="col-md-6 m-3">
                        <a href={preview} target="_blank" rel="noopener noreferrer">
                            <img src={preview} alt="Selected" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                        </a>
                    </div>
                </div>
            ))}


        </>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.Auth,
    };
};

export default connect(mapStateToProps)(SchoolReport);
